import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ReservationSettingsComponent } from '../reservation-settings/reservation-settings.component';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { ProductOffering } from 'anchor-shared/lib/model/entity/productOffering';
import { ProductOfferingFormComponent } from '../product-offering-form/product-offering-form.component';

@Injectable({
  providedIn: 'root',
})
export class VesselAvailabilityDialogService {
  config: any = {
    maxWidth: '100vw',
    height: '100vh',
    width: '100%',
    hasBackdrop: false,
  };

  constructor(private dialog: MatDialog) {}

  public openReservationSettingsDialog(
    vessel: Vessel,
    settingsType: string,
  ): Observable<boolean> {
    let dialogRef: MatDialogRef<ReservationSettingsComponent>;
    this.config.data = {
      vessel: vessel,
      settingsType: settingsType,
    };
    dialogRef = this.dialog.open(ReservationSettingsComponent, this.config);
    return dialogRef.afterClosed();
  }

  public openProductOfferingDialog(
    vessel: Vessel,
    productOffering?: Partial<ProductOffering>,
  ): Observable<boolean> {
    let dialogRef: MatDialogRef<ProductOfferingFormComponent>;
    this.config.data = { vessel: vessel, productOffering: productOffering };
    dialogRef = this.dialog.open(ProductOfferingFormComponent, this.config);
    return dialogRef.afterClosed();
  }
}
